/** Normaliza /api/categorias → siempre Todas + 13 secciones catálogo agosto. */

export const CATEGORIA_META = {
  Todas: { label: 'Todas', blurb: 'Catálogo completo para armar el pedido' },
  ASESORIOS: { label: 'Accesorios', blurb: 'Accesorios y utilidades' },
  'ASESORIOS CABELLO': { label: 'Accesorios cabello', blurb: 'Accesorios para el cabello' },
  BARBERIA: { label: 'Barbería', blurb: 'Barbería y cuidado masculino' },
  'BRILLOS Y SOMBRAS': { label: 'Brillos y sombras', blurb: 'Brillos, sombras e iluminadores' },
  'BROCHAS Y PINCELES': { label: 'Brochas y pinceles', blurb: 'Brochas, pinceles y aplicadores' },
  COSMETIQUERAS: { label: 'Cosmetiqueras', blurb: 'Cosmetiqueras y organizadores' },
  ELECTRICOS: { label: 'Eléctricos', blurb: 'Lámparas, secadores y eléctricos' },
  ESMALTES: { label: 'Esmaltes', blurb: 'Esmaltes y semipermanentes' },
  'FACIAL Y CORPORAL': { label: 'Facial y corporal', blurb: 'Cuidado facial y corporal' },
  'PEINILLAS Y CEPILLOS': { label: 'Peinillas y cepillos', blurb: 'Peinillas, cepillos y peines' },
  PESTAÑAS: { label: 'Pestañas', blurb: 'Pestañas, pinzas y accesorios' },
  'STICKER FACIAL': { label: 'Sticker facial', blurb: 'Stickers y decoración facial' },
  'UÑAS': { label: 'Uñas', blurb: 'Uñas, tips, geles y herramientas' },
  'Manicure y Pedicure': { label: 'Uñas', blurb: 'Uñas, tips, geles y herramientas' },
};

export const CATALOGO_AGOSTO_SECCIONES = [
  'ASESORIOS',
  'ASESORIOS CABELLO',
  'BARBERIA',
  'BRILLOS Y SOMBRAS',
  'BROCHAS Y PINCELES',
  'COSMETIQUERAS',
  'ELECTRICOS',
  'ESMALTES',
  'FACIAL Y CORPORAL',
  'PEINILLAS Y CEPILLOS',
  'PESTAÑAS',
  'STICKER FACIAL',
  'UÑAS',
];

function catalogoAgostoNombre(nombre) {
  const n = String(nombre || '')
    .trim()
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  if (n === 'ACCESORIOS') return 'ASESORIOS';
  if (n === 'ACCESORIOS CABELLO') return 'ASESORIOS CABELLO';
  return n;
}

export function categoriaLabel(nombre) {
  const n = String(nombre || '').trim();
  const key =
    CATALOGO_AGOSTO_SECCIONES.find((s) => catalogoAgostoNombre(s) === catalogoAgostoNombre(n)) || n;
  return CATEGORIA_META[key]?.label || CATEGORIA_META[n]?.label || n;
}

export function canonicalCategoriaNombre(nombre) {
  const n = String(nombre || '').trim();
  if (!n || n === 'Todas') return n;
  const key = catalogoAgostoNombre(n);
  const hit = CATALOGO_AGOSTO_SECCIONES.find((s) => catalogoAgostoNombre(s) === key);
  if (hit) return hit;
  if (n === 'Manicure y Pedicure') return 'UÑAS';
  if (n === 'Capilar') return 'Cabello';
  return n;
}

function enrichChip(c) {
  const nombre = String(c?.nombre || '').trim();
  const key =
    CATALOGO_AGOSTO_SECCIONES.find((s) => catalogoAgostoNombre(s) === catalogoAgostoNombre(nombre)) ||
    nombre;
  return {
    ...c,
    nombre: key,
    label: c.label || categoriaLabel(key),
    blurb: c.blurb || CATEGORIA_META[key]?.blurb || '',
  };
}

function filterSoloCatalogoAgosto(list = []) {
  const byName = new Map();
  for (const c of list || []) {
    if (!c || c.nombre === 'Todas') continue;
    const key = catalogoAgostoNombre(c.nombre);
    const canon = CATALOGO_AGOSTO_SECCIONES.find((s) => catalogoAgostoNombre(s) === key);
    if (!canon) continue;
    const prev = byName.get(canon);
    if (!prev) byName.set(canon, enrichChip({ ...c, nombre: canon }));
    else
      byName.set(
        canon,
        enrichChip({
          ...prev,
          total: (Number(prev.total) || 0) + (Number(c.total) || 0),
          id: prev.id || c.id,
        })
      );
  }
  return CATALOGO_AGOSTO_SECCIONES.map((nombre, i) => {
    const hit = byName.get(nombre);
    return hit || enrichChip({ id: nombre, nombre, total: 0, orden: (i + 1) * 10 });
  });
}

function buildCatalogoAgostoChips(list = []) {
  const rest = filterSoloCatalogoAgosto(list);
  const sum = rest.reduce((s, c) => s + (Number(c.total) || 0), 0);
  return [enrichChip({ id: 'todas', nombre: 'Todas', total: sum }), ...rest];
}

export function normalizeCategorias(data = []) {
  const raw = (data || [])
    .filter((c) => c && c.nombre && c.nombre !== 'General' && c.nombre !== 'Otros')
    .map((c) =>
      enrichChip({
        id: c.id,
        nombre: String(c.nombre || '').trim(),
        total: Number(c.total) || 0,
        orden: Number(c.orden) || 100,
        label: c.label,
        blurb: c.blurb,
      })
    );

  const parent = (data || []).find((c) => Array.isArray(c.subcategorias) && c.subcategorias.length);
  const flat =
    parent &&
    !raw.some((c) =>
      CATALOGO_AGOSTO_SECCIONES.some((s) => catalogoAgostoNombre(s) === catalogoAgostoNombre(c.nombre))
    )
      ? parent.subcategorias
          .filter((c) => c.nombre !== 'Otros')
          .map((c) =>
            enrichChip({
              id: c.id,
              nombre: String(c.nombre || '').trim(),
              total: Number(c.total) || 0,
              orden: Number(c.orden) || 100,
            })
          )
      : raw.filter((c) => c.nombre !== 'Todas');

  const chips = buildCatalogoAgostoChips(flat);
  const apiTodas = (data || []).find((c) => c && c.nombre === 'Todas');
  if (apiTodas && apiTodas.total != null) {
    chips[0].total = Number(apiTodas.total) || chips[0].total;
  }
  return chips;
}

export const FALLBACK_CATEGORIAS = buildCatalogoAgostoChips([]);
